import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetLand } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetLandField } from '../../../../../queries/useBudgetLandField';

interface TelephoneCableFiberOpticProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const TelephoneCableFiberOptic: React.FC<TelephoneCableFiberOpticProps> = ({
    required = false,
    propertyGuid,
    isReview = false,
}) => {
    const [telephoneCableFiberOptic, set_telephoneCableFiberOptic] = useBudgetLandField<number>(
        propertyGuid,
        (b) => (b.values?.['Utilities']?.['Telephone, Cable, and Fiber Optic Lines'] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Utilities': { ...b.values?.['Utilities'], 'Telephone, Cable, and Fiber Optic Lines': v } } })
    );
    const label = 'Telephone, Cable, and Fiber Optic Lines';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(telephoneCableFiberOptic)}
                />
            ) : (
                <MoneyBox
                    id={'telephoneCableFiberOptic'}
                    allowNegative={false}
                    value={telephoneCableFiberOptic}
                    onChange={(value) => set_telephoneCableFiberOptic(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
